import { Loader2 } from 'lucide-react';
import { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

interface AnimateSpinProps extends ComponentProps<'svg'> {}

export function AnimateSpin(props: AnimateSpinProps) {
  return (
    <Loader2
      {...props}
      className={cn('h-6 w-6', props.className, 'animate-spin')}
    />
  );
}
